import { environment } from '@core/environment';
import { Project } from '@projects/types';

export const getOneDriveLink = (project: Project) => {
  const { oneDriveUrl } = environment;

  const path = `/${project.organizationName}/${project.name}/01_Design_Data`;
  const invalidChars = /[<>:"?*|\\]/g;
  const sanitizedPath = path.replace(invalidChars, '_');

  return oneDriveUrl + encodeURIComponent(sanitizedPath);
};
